import { combineReducers } from "redux";
import UseReducer from "../Users/userReducer.jsx";
import fieldReducer from "../Users/fieldReducer.js";
import roundReducer from "../Users/roundReducer.js";
import entryFieldReducer from "../Users/EntryFieldREducer.js";

const rootReducer = combineReducers({
    users: UseReducer,
    field: fieldReducer,
    round: roundReducer,
    entry: entryFieldReducer,

})

export default rootReducer;